import { render, staticRenderFns } from "./SGStreams.vue?vue&type=template&id=16007f76"
import script from "./SGStreams.vue?vue&type=script&lang=js"
export * from "./SGStreams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports